export default __webpack_public_path__ + "static/media/X3PD01.ae635e79.svg";